import { NavigationItem } from "@/config/navigation/types";
import { Reorder } from "framer-motion";
import { SortAndToggleableListItem } from "./sort-and-toggleable-list-item";

interface SortAndToggleableListProps {
  items: NavigationItem[];
  toggledOffIds: string[];
  onReorder: (items: NavigationItem[]) => void;
  onToggle: (id: string, toggledOff: boolean) => void;
}

export function SortAndToggleableList({ items, toggledOffIds, onReorder, onToggle }: SortAndToggleableListProps) {
  return (
    <Reorder.Group axis="y" values={items} onReorder={onReorder} className="space-y-2">
      {items.map((item) => (
        <SortAndToggleableListItem
          key={item.id}
          item={item}
          isToggledOff={toggledOffIds.includes(item.id)}
          onToggle={(toggledOff) => onToggle(item.id, toggledOff)}
        />
      ))}
    </Reorder.Group>
  );
}
